import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import AppointmentForm from '../Appointment';
import GettyImagesGrowthChart from '../../assets/video/GettyImages-GrowthChart.mp4';


const BannerDefault = () => {

    const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);

    return (
        <React.Fragment>

            {/* <!-- banner section start --> */}
            <div className="rs-banner style1">

                <div className="banner-height pt-100 pb-100 md-pt-80 md-pb-80">
                    <div className="container">
                        <div className="row">
                            <video autoPlay muted loop className="video-bg">
                                <source src={GettyImagesGrowthChart} type="video/mp4" />
                            </video>
                            <div className="col-lg-7 col-md-12 pt-40 pr-140 md-pt-0 md-mb-60 md-pr-14">

                                <div className="banner-content">

                                    <h5 className="bnr-title" data-animation="fadeInLeft" data-delay=".3s">
                                        Optimize,Innovate and Grow with Expert IT Consulting
                                    </h5>
                                    <p className="bnr-desc" data-animation="fadeInLeft" data-delay=".5s">
                                        Leverage cutting-edge technology and strategic solutions tailored to your business needs. Our IT consulting services help streamline operations, boost productivity, and drive efficiency—empowering your business for long-term success.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12 pl-70 lg-pl-30 md-pl-14">
                                <AppointmentForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <!-- banner section end --> */}

        </React.Fragment>
    );
}

export default BannerDefault;